export const getDotValue = <T extends Record<string, any>>(data: T, key: string) => {
  return key.split('.').reduce((m, n) => (m = m?.[n]), data);
};

export const sortWithConditions = <T extends Record<string, any>>(
  source?: T[],
  sortArray?: Array<[string, 'asc' | 'desc' | undefined]>,
) => {
  const validSortArray = sortArray?.filter(([key, sort]) => key && sort);

  if (!source || !validSortArray?.length) return source;

  return source.slice().sort((a, b) => {
    return validSortArray.reduce((m, [key, sortType]) => {
      if (m !== 0) {
        return m;
      }

      const orderNum = sortType === 'asc' ? 1 : -1;

      const av = getDotValue(a, key) ?? (orderNum === 1 ? Infinity : -Infinity);
      const bv = getDotValue(b, key) ?? (orderNum === 1 ? Infinity : -Infinity);

      return av === bv ? 0 : av > bv ? orderNum : -orderNum;
    }, 0);
  });
};

/**
 *
 * https://stackoverflow.com/questions/40929260/find-last-index-of-element-inside-array-by-certain-condition
 * Returns the index of the last element in the array where predicate is true, and -1
 * otherwise.
 * @param array The source array to search in
 * @param predicate find calls predicate once for each element of the array, in descending
 * order, until it finds one where predicate returns true. If such an element is found,
 * findLastIndex immediately returns that element index. Otherwise, findLastIndex returns -1.
 */
export function findLastIndex<T>(
  array: Array<T>,
  predicate: (value: T, index: number, obj: T[]) => boolean,
): number {
  let l = array.length;
  while (l--) {
    if (predicate(array[l], l, array)) return l;
  }
  return -1;
}
